["1.8.8","1.9","1.10","1.11.2","1.12","1.13","1.13.2","1.14.4","1.15.2","1.16.1","1.16.4","1.17.1","1.18.1","1.19.1"]